import "./index.scss";
import { Button } from "@wise-emotions/react-button";
import { Label } from "@wise-emotions/react-label";
import { Poly } from "components/Poly";
import { PolyAnchor } from "components/Anchor/utils";
import React, { ReactNode } from "react";

export type CardCartProps = {
  title: string;
  orderDetails: ReactNode;
  promoInfo?: ReactNode;
  summaryLabel: string;
  oldPrice?: ReactNode;
  price: string;
  priceDetail?: string;
  ctaLabel: string;
  ctaAnchor: (children: ReactNode) => JSX.Element;
};

export const CardCart = ({
  title,
  orderDetails,
  summaryLabel,
  oldPrice,
  price,
  priceDetail,
  ctaAnchor,
  ctaLabel,
  promoInfo,
}: CardCartProps) => {
  return (
    <div id="cardCart" className="card-cart">
      <Label variant="default" isBold title={title} htmlFor="cardCart" />
      <div className="card-cart__order-detail">{orderDetails}</div>
      {promoInfo}
      <div className="card-cart__divider" />
      <Label
        variant={oldPrice ? "counter" : "default"}
        isBold
        title={summaryLabel}
        htmlFor=""
        counter={oldPrice}
      />
      <div className="card-cart__price">{price}</div>
      <div className="card-cart__price-description">{priceDetail}</div>
      <div className="card-cart__cta">
        {ctaAnchor(
          <Button variant="default" size="lg">
            {ctaLabel}
          </Button>,
        )}
      </div>
    </div>
  );
};

CardCart.displayName = "CardCart";
